import React, { useState } from 'react';
import {
  Box, Card, CardContent, Typography, TextField, Button, Alert,
  Container, CircularProgress, IconButton, InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { platformAdminAPI } from '../../services/api';

const ADMIN_TOKEN_KEY = 'platform_admin_token';
const ADMIN_USER_KEY = 'platform_admin_user';

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await platformAdminAPI.login({ email, password });
      localStorage.setItem(ADMIN_TOKEN_KEY, data.token);
      localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(data.admin));
      onLogin(data.admin);
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
        <Card sx={{ width: '100%', maxWidth: 400 }}>
          <CardContent sx={{ p: 4 }}>
            <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
              <Box component="img" src="/Logo.png" alt="School Sync Logo" sx={{ width: 70, height: 70, objectFit: 'contain', mb: 1 }} />
              <Typography variant="h5" fontWeight={600} textAlign="center" gutterBottom>
                Central Admin Panel
              </Typography>
              <Typography variant="body2" color="text.secondary" textAlign="center">
                Platform administration access
              </Typography>
            </Box>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <Box component="form" onSubmit={handleSubmit}>
              <TextField fullWidth type="email" label="Email" value={email}
                onChange={(e) => setEmail(e.target.value)} required margin="normal" />
              <TextField fullWidth type={showPassword ? 'text' : 'password'} label="Password" value={password}
                onChange={(e) => setPassword(e.target.value)} required margin="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }} />
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }} disabled={loading}>
                {loading ? <CircularProgress size={22} /> : 'Sign In'}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export { ADMIN_TOKEN_KEY, ADMIN_USER_KEY };
export default AdminLogin;
